/**
 * True when running on an Apple platform (macOS / iOS). Used only for
 * presentational choices — e.g. showing the ⌘ modifier instead of Ctrl in
 * keyboard-shortcut affordances. The Cmd+K listener itself accepts either
 * modifier regardless (see `AppLayout`), so this never gates behaviour.
 *
 * Falls back to `false` outside the browser (SSR / tests) so the generic Ctrl
 * label is the default.
 */
export function isApplePlatform(): boolean {
  if (typeof navigator === 'undefined') return false;
  const uaData = (
    navigator as Navigator & { userAgentData?: { readonly platform?: string } }
  ).userAgentData;
  // `userAgentData.platform` ("macOS") when available; otherwise fall back to
  // the UA string ("Macintosh", "iPhone", …). `navigator.platform` is avoided
  // as it's deprecated.
  const platform = uaData?.platform ?? navigator.userAgent;
  return /mac|iphone|ipad|ipod/i.test(platform);
}
